import React from 'react';
import Progress from 'app/components/widgets/order/Progress';
import {Currency, Image, Text} from '@morningtrain/react-displays';
import {CollectionContext, ForEachModel, ModelContext, WhenModelValue} from "@morningtrain/react-resources";
import {getMapValue} from "@morningtrain/react-helpers";

const Table = require('components/layouts/Table');
const BaseRow = require('components/layouts/BaseRow');
const IndexColumn = require('components/columns/IndexColumn').inject();
const TextColumn = require('components/columns/TextColumn').inject();
const CurrencyColumn = require('components/columns/CurrencyColumn').inject();
const Trans = require('app/components/trans/Trans')

export default class OrderOverview extends React.Component {

  static contextType = ModelContext;

  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };

    this.close = this.close.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  get progress() {
    const status = getMapValue(this.context, 'status');

    return Object.keys(status || {}).map(key => {
      return {
        label: key,
        time: status[key],
      };
    });
  }

    get toggleLabel() {
        return this.state.open
            ? translate('Luk detaljeret oversigt')
            : translate('Se detaljer for ordren');
    }

    get distributor () {
        return getMapValue(this.context, 'distributor', null)
    }

    close() {
        this.setState({open: false});
    }

    toggle() {
        this.setState(state => ({open: !state.open}));
    }

    renderContent() {
        if (!this.state.open) return null;

        const lines         = getMapValue(this.context, 'lines');
        const accessories   = getMapValue(this.context, 'accessories');
        const notes         = getMapValue(this.context, 'notes');

        return (
            <React.Fragment>
                <div className='order-row no-border'>
                    <div className='delivery-details customer-details'>
                        <div>
                            <div className='name'>Modtager</div>
                            <ul>
                                <li>
                                   <span>
                                       <b><Text name={'delivery_type'}/>s tidspunkt: </b>
                                       <Text name={'delivery_date'}/>
                                   </span>
                                </li>
                                <li>
                                   <span>
                                       <b><Text name={'delivery_type'}/>s adresse: </b>
                                       <Text name={'delivery_address'}/>
                                   </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className='order-row no-border'>
                    <Table collection={lines}>
                        <BaseRow>
                            <IndexColumn className={'medium'}/>
                            <TextColumn label={ translate('Produkt')} name={'type'}
                                        className={'large'}/>
                            <TextColumn label='Type' name={'product'}
                                        className={'large orderline-note-column'}/>
                            <CurrencyColumn label={ translate('Pris')} name={'price'}
                                            alignment={'right'}/>
                        </BaseRow>
                    </Table>
                </div>

                <div className='order-row no-border'>
                    <div className='order-accessories'>
                        <CollectionContext.Provider value={accessories}>
                            <ForEachModel>
                                <div className='order-card'>
                                    <div className='title'>
                                        Tekst på <Text name={'type'}/>:<br/>
                                    </div>
                                    <div className='card-info'>
                                        <div className='text'>
                                            <p><Text name={'notes'}/></p>
                                        </div>
                                    </div>
                                </div>
                            </ForEachModel>
                        </CollectionContext.Provider>
                    </div>

                  <WhenModelValue name={'img'}>
                    <div className='thumbnail'>
                      <Image name={'img'} alt={'product image'}/>
                    </div>
                  </WhenModelValue>

                  <div className='order-total'>
                    <ul>
                      <li>
                        <span>Subtotal:</span>
                        <p><Currency name='subtotal' /></p>
                      </li>
                      <li>
                        <span>Moms:</span>
                        <p><Currency name='tax' /></p>
                      </li>
                    </ul>
                    <p className='price'><Currency name={'total'}/></p>
                    <p className='tax'><Trans>Total inkl. moms</Trans></p>
                  </div>
                </div>

                <WhenModelValue name={'status'}>
                    <div className='order-row no-border'>
                        <Progress steps={this.progress} distributor={this.distributor}/>
                    </div>
                </WhenModelValue>

                <WhenModelValue name={'display_fallback'} condition={true}>
                    <div className='order-row no-border'>
                        <p className={'status-fallback'}>
                           <Trans> Der er ingen tracking på denne ordre. Så fremt du intet hører
                            fra
                            os, så vil denne ordre blive leveret j.f. vores almindelige
                            leveringstider (mellem kl. 08.00 og 19.00 på hverdage - dog
                            med
                            forbehold for helligedage). For info omkring denne ordre Skriv
                            da en mail til: <a href={'mailto:kundeservice@bloomit.dk'}>kundeservice@bloomit.dk</a> </Trans>
                        </p>
                    </div>
                </WhenModelValue>

                <WhenModelValue name={'notes'}>
                    <div className='order-row no-border'>
                        <div className='order-notes'>
                          <h3><Trans> Leverings bemærkninger: </Trans> </h3>
                          <div className={'notes'}>
                            <CollectionContext.Provider value={notes}>
                              <ForEachModel>
                                <div className={'note'}>
                                  <p className={'msg'}><Text name={'message'}/></p>
                                  <span className={'time'}><Text name={'timestamp'}/></span>
                                </div>
                              </ForEachModel>
                            </CollectionContext.Provider>
                          </div>
                        </div>
                    </div>
                </WhenModelValue>
            </React.Fragment>
        );
    }

    render() {

        return (
            <div className={'section'}>
                <div className='order-box content-box'>

                    <div className='order-row'>
                        <div className={'order-heading'}>
                            <h2><Text name={'number'}/></h2>
                            <p><Text name={'delivery_address'}/></p>
                        </div>
                        <div className='order-actions'>
                            <WhenModelValue name={'status'}>
                                <button className={'btn outline disabled gold'}>FØLG DIN
                                    ORDRE
                                </button>
                            </WhenModelValue>
                            <button className={'btn'}
                                    onClick={this.toggle}>{this.toggleLabel}</button>
                        </div>
                    </div>

                    {this.renderContent()}
                </div>
            </div>
        );
    }
}
